import { Component, Input } from "@angular/core";
import { AppConfigService } from "src/app/core";
import { CustomerVariantSkuSubCategory } from "../../models/customer-variant-sku-category";

@Component({
  selector: "app-item-request-wizard-sku-request-price",
  templateUrl: "./item-request-wizard-sku-request-price.component.html",
  styleUrl: "./item-request-wizard-sku-request-price.component.scss",
  standalone: false,
  host: {
    "[style.display]": 'subCategory.customerRequestSupported && !subCategory.customerUploadSupported ? "block" : "none"',
  },
})
export class ItemRequestWizardSkuRequestPriceComponent {
  itemRequestProcessingDays: string;

  @Input() subCategory: CustomerVariantSkuSubCategory;

  constructor(private _appConfigService: AppConfigService) {
    this.itemRequestProcessingDays = this._appConfigService.itemRequestProcessingDays;
  }
}
